const binding = { modules: {}, dataActions: {} };

    (binding.modules['simple-form'] = {
        c: () => require('partner/modules/simple-form/simple-form.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'simple-form',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/simple-form'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };